<div id="main-content">
  <div class="container-fluid">
    <app-breadcrumb [dataInput]="breadCrumb"></app-breadcrumb>





    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card">
          <div class="header">


          </div>
          <div class="body mt-2">








          </div>
        </div>
      </div>

    </div>

  </div>
</div>
